import React, { ReactElement } from 'react'
import { Helmet } from 'react-helmet'
import { injectIntl, IntlShape, WrappedComponentProps } from 'react-intl'

// Opt-in helper for adding "| BRAND_NAME Store Search" suffix
export const createPageTitle = (title: string, intl: IntlShape): string =>
  `${title} ${intl.formatMessage({
    id: 'text_store_locator_details_meta_title',
  })}`

type Props = {
  title: string
  description: string
  canonicalUrl?: string
  shouldAddNoIndexMeta?: boolean
  children?: ReactElement<any>
} & WrappedComponentProps
const Meta: React.FC<Props> = ({
  intl,
  title,
  description,
  children,
  canonicalUrl,
  shouldAddNoIndexMeta,
  ...props
}) => {
  const link = canonicalUrl ? [{ rel: 'canonical', href: canonicalUrl }] : []
  const noIndexText = shouldAddNoIndexMeta ? (
    <meta name="robots" content="noindex" />
  ) : null
  return (
    <Helmet title={title} {...props} link={link}>
      <meta name="description" content={description} />
      {noIndexText}
      {children}
    </Helmet>
  )
}
export default injectIntl(Meta)
